<template>
  <div id="app" class="relative">
    <Header />
    <div class="relative">
      <transition name="circle">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "./components/MainHeader.vue";

export default defineComponent({
  name: "App",
  components: {
    Header,
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  margin: 0;
}
.circle-enter-active > div,
.circle-enter-active svg {
  -webkit-animation-name: cubicslow;
  -webkit-animation-duration: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1.25);
  -webkit-animation-fill-mode: forwards;
}
.circle-enter-active > div > div,
.circle-enter-active > section > div {
  -webkit-animation-name: cubic;
  -webkit-animation-duration: 1s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1.25);
  -webkit-animation-fill-mode: forwards;
}
@keyframes cubic {
  0% {
    transform: translateY(260%);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes cubicslow {
  0% {
    transform: translateY(10%);
  }
  100% {
    transform: translateY(0);
  }
}
.circle-enter-active {
  transition: all 1s ease;
  /* -webkit-animation-name: slideleft;
  -webkit-animation-duration: 1s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -webkit-animation-fill-mode: forwards; */
}
.circle-leave-active {
  /* -webkit-animation-name: slideright;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -webkit-animation-fill-mode: forwards; */
}

@keyframes slideleft {
  from {
    background: white;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    transform: translateX(-100%);
  }
  to {
    background: white;
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
    transform: translateX(0);
  }
}
@keyframes slideright {
  from {
    background: white;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    transform: translateX(0);
  }
  to {
    background: white;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    transform: translateX(100%);
  }
}
</style>
